import type { ReactNode } from 'react'
import { clsx } from 'clsx'

export interface EmptyStateProps {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center text-center py-12 px-6',
        className
      )}
    >
      {icon && <div className="mb-4 p-4 bg-neutral-100 rounded-full text-neutral-400">{icon}</div>}
      <h3 className="text-lg font-medium text-neutral-900">{title}</h3>
      {description && <p className="mt-2 text-sm text-neutral-500 max-w-sm">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  )
}
